/* eslint-disable */
/* eslint-disable indent, react/jsx-indent, no-trailing-spaces */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import moment from 'moment';
import MuiErrorCircleIcon from '@material-ui/icons/Error';
import { currencyFromCents } from 'Helpers/Formats';
import { combineNames } from 'Helpers/Client';
import { wasFailedPayment } from 'Helpers/invoice';
import Button from 'Components/UI/Button';
import { displayErrorMessage, displaySuccess } from 'Helpers/FacetNotificationManager';

const baseStyle = makeStyles(theme => ({
  w100: {
    width: '100%',
  },
  font14px: {
    fontSize: '14px',
  },
  stripedRow: {
    backgroundColor: '#f6f6f6',
  },
  paymentError: {
    color: theme.palette.error.main,
  },
  paymentErrorIcon: {
    marginRight: theme.spacing(1),
  },
  tablePadding: {
    '& td': {
      padding: theme.spacing(1),
    },
  },
  finePrint: {
    color: theme.palette.facet.primaryGray2,
    fontSize: '10px',
    marginTop: theme.spacing(1),
  },
}));

const paymentMethod = invoice => {
  return invoice.attr('paymentMethodDisplay');
};

const emailReceipt = async invoice => {
  let emailRequest;
  try {
    emailRequest = await invoice.relationship('receiptEmail').link('related').get();
    [emailRequest] = await emailRequest.link('self').post();
  } catch (e) {
    displayErrorMessage(e, 'Failed to send receipt. Please try again.');
    return;
  }
  displaySuccess(`Your receipt was emailed to ${emailRequest.attr('to')}`);
};

const Receipt = ({ invoice, household, isAgentView = false }) => {
  const [emailMeButtonDisabled, setEmailMeButtonDisabled] = useState(false);

  const classes = baseStyle();

  const clientNames = combineNames(
    household.attr('primaryClientFirstName'),
    household.attr('primaryClientLastName'),
    household.attr('spouseClientFirstName'),
    household.attr('spouseClientLastName'),
  );

  const createdAt = moment.utc(invoice.attr('createdAt')).format('MMMM D, YYYY');
  const paidAt = invoice.attr('paidAt')
    ? moment.utc(invoice.attr('paidAt')).format('MMMM D, YYYY')
    : '';

  const finePrint = isAgentView
    ? (<></>)
    : (
      <p className={classnames(classes.finePrint)}>
        You have authorized Facet to automatically charge you the above price periodically until you
        cancel.  If the price changes, we will notify you beforehand.  You can cancel your renewal date or cancel any
        time by emailing&nbsp;
        <a href="mailto:support@facetwealth.com">support@facetwealth.com</a>.&nbsp;
        <a
          href="https://facetwealth.com/legal-documents/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms and conditions
        </a> apply.
      </p>
    );

  const viewEmailReceiptButton = () => {
    if (isAgentView) return null;
    if (wasFailedPayment(invoice)) return null;

    return (
      <div style={{ textAlign: 'center' }}>
        <Button
          color="secondary"
          disabled={emailMeButtonDisabled}
          onClick={async () => {
            setEmailMeButtonDisabled(true);
            await emailReceipt(invoice);
            setEmailMeButtonDisabled(false);
          }}
          variant={'contained'}
          padding={'squished'}
        >
          Email Receipt
        </Button>
      </div>
    );
  };

  return (
    <>
      <table className={classnames(classes.w100, classes.font14px, classes.tablePadding)}>
        <tr className={classnames(classes.stripedRow)}>
          <td><b>Household</b></td>
          <td>{clientNames}</td>
        </tr>
        <tr>
          <td><b>Created On</b></td>
          <td>{createdAt}</td>
        </tr>
        <tr className={classnames(classes.stripedRow)}>
          <td><b>Paid On</b></td>
          <td>{paidAt}</td>
        </tr>
        <tr>
          <td><b>Receipt ID</b></td>
          {wasFailedPayment(invoice)
            ? (
              <td colSpan={2} className={classnames(classes.paymentError)}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <MuiErrorCircleIcon className={classnames(classes.paymentErrorIcon)} />
                  PAYMENT FAILED
                </div>
              </td>)
            : (<td>{invoice.attr('invoiceNumber')}</td>)
          }
        </tr>
        <tr className={classnames(classes.stripedRow)}>
          <td><b>Payment Method</b></td>
          <td>{paymentMethod(invoice)}</td>
        </tr>
        <tr>
          <td><b>Service Provider</b></td>
          <td>Facet</td>
        </tr>
        <tr className={classnames(classes.stripedRow)}>
          <td><b>Address</b></td>
          <td>400 East Pratt Street, 8th Floor Baltimore, MD 21202</td>
        </tr>
        <tr>
          <td><b>Product</b></td>
          <td>Financial Planning</td>
        </tr>
        <tr className={classnames(classes.stripedRow)}>
          <td><b>Tax</b></td>
          <td>$0</td>
        </tr>
        <tr>
          <td><b>Total</b></td>
          <td>{currencyFromCents(invoice.attr('amountDue'), false)}</td>
        </tr>
      </table>
      {finePrint}
      {viewEmailReceiptButton()}
    </>
  );
};

export default Receipt;

Receipt.propTypes = {
  invoice: PropTypes.object.isRequired,
};

Receipt.defaultProps = {};
